import React from 'react';
import { Link } from 'react-router-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

import companyImg from '../../assets/img/company/company-1.png';
import tabImg1 from '../../assets/img/company/company-tab-1.png';
import tabImg2 from '../../assets/img/company/company-tab-1.png';
import tabImg3 from '../../assets/img/company/company-tab-1.png';

const Company = () => {
  let tab1 = 'Our Vision',
    tab2 = 'Our Mission',
    tab3 = 'Our Core Values';
  const tabStyle = 'nav nav-tab';

  return (
    <div className="company__area pb-100">
      <div className="container">
        <div className="row align-items-center">
          <div
            className="col-xl-6 wow animate__fadeInLeft"
            data-wow-duration="1.1s"
            data-wow-delay=".5s"
          >
            <div className="company__left-img text-center text-xl-start">
              <img src={companyImg} alt="" />
            </div>
          </div>
          <div
            className="col-xl-6 wow animate__fadeInRight"
            data-wow-duration="1.1s"
            data-wow-delay=".5s"
          >
            <div className="company__section-box">
              <h4 className="section-subtitle char-anim">
                One Team. Infinite Possibilities.
              </h4>
              <h3 className="section-title pb-10 char-anim">
                Tailored Tech Solutions for Every Business.
              </h3>
              <p className="char-anim-2">
                At <b>TGVC Technologies</b>, we understand that no two businesses are alike. That’s why we offer custom-built solutions designed to meet your unique challenges — from strategy and design to full-scale development.
                Whether you're building an app, launching a website, or scaling digital operations, we’ve got you covered.
              </p>
            </div>
            <Tabs>
              <div className="company__service-tab">
                <TabList className={tabStyle}>
                  <Tab>
                    <button className="btn-color-1">
                      <span>{tab1}</span>
                    </button>
                  </Tab>
                  <Tab>
                    <button className="btn-color-2">
                      <span>{tab2}</span>
                    </button>
                  </Tab>
                  <Tab>
                    <button className="btn-color-3">
                      <span>{tab3}</span>
                    </button>
                  </Tab>
                </TabList>
                <div className="tab-content" id="myTabContent">
                  <TabPanel>
                    <div className="company__tab-content-wrapper d-flex align-items-center">
                      <div className="company__tab-icon">
                        <span>
                          <img src={tabImg1} alt="" />
                        </span>
                      </div>
                      <div className="company__tab-text">
                        <h4>Shaping the Future Through Technology</h4>
                        <span>To become a globally trusted technology partner by delivering transformative, domain-agnostic solutions that shape the future of business.</span>
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel>
                    <div className="company__tab-content-wrapper d-flex align-items-center">
                      <div className="company__tab-icon">
                        <span>
                          <img src={tabImg2} alt="" />
                        </span>
                      </div>
                      <div className="company__tab-text">
                        <h4>Building Intelligent Solutions for a Smarter World</h4>
                        <span>To empower organizations with reliable, high-impact technologies that align with their goals, accelerate growth, and enable long-term success.</span>
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel>
                    <div className="company__tab-content-wrapper d-flex align-items-center">
                      <div className="company__tab-icon">
                        <span>
                          <img src={tabImg3} alt="" />
                        </span>
                      </div>
                      <div className="company__tab-text">
                        <h4>Our DNA: Integrity. Innovation. Impact.</h4>
                        <span>
                          We operate with integrity, driven by innovation, and focused on creating lasting impact — ensuring every solution is ethical, forward-thinking, and value-driven.
                        </span>
                      </div>
                    </div>
                  </TabPanel>
                </div>
              </div>
            </Tabs>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Company;
